import React from 'react';
import './tabButtons.css';

interface RoundedTabsProps {
  options: string[];
  selected: string;
  onChange: (val: string) => void;
}

const TabButtons: React.FC<RoundedTabsProps> = ({ options, selected, onChange }) => {
  return (
    <div className="rounded-tabs-container">
      {options.map((option) => (
        <button
          key={option}
          className={`rounded-tab ${selected === option ? 'selected' : ''}`}
          onClick={() => onChange(option)}
        >
          {option}
        </button>
      ))}
    </div>
  );
};

export default TabButtons;